var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.99 179.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a8c0;}.cls-2,.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-2{stroke-width:4px;}.cls-3{fill:#fff;}.cls-4{stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 91.5,
    cy: 90,
    rx: 91.5,
    ry: 90
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.25,49.27,30.66,49.2a2.15,2.15,0,0,0-2.16,2.15l-.05,68.29a2.17,2.17,0,0,0,2.16,2.16l121.59.08a2.17,2.17,0,0,0,2.17-2.16l0-68.28A2.17,2.17,0,0,0,152.25,49.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.6,129a1.42,1.42,0,0,1-1.35,1.5l-30.34,1.77a1.44,1.44,0,0,1-1.5-1.36h0a1.43,1.43,0,0,1,1.36-1.5l30.34-1.76A1.43,1.43,0,0,1,90.6,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.21,129a1.41,1.41,0,0,0,1.35,1.5l30.34,1.81a1.42,1.42,0,0,0,1.49-1.36h0a1.42,1.42,0,0,0-1.35-1.5l-30.33-1.8a1.43,1.43,0,0,0-1.5,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.42,129.76a1.42,1.42,0,0,1-1.2,1.62L54.07,136.5a1.42,1.42,0,0,1-1.62-1.2h0a1.43,1.43,0,0,1,1.21-1.62l35.15-5.13a1.42,1.42,0,0,1,1.61,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.38,129.76a1.43,1.43,0,0,0,1.21,1.62l35.14,5.18a1.44,1.44,0,0,0,1.62-1.21h0a1.45,1.45,0,0,0-1.21-1.63L94,128.55a1.45,1.45,0,0,0-1.63,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.42,122l-2.83,9.34a16.38,16.38,0,0,0-4.37,0L86.4,122Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 33.46,
    y: 53.35,
    width: 116,
    height: 63.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.8a0b9b0999d716aa37067ab8427c3341.svg";
export { ForwardRef as ReactComponent };